//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        title: String,
        titleIcon: String,
        subtitle: String,
        footerIcon: String,
        okLabel: String,
        cancelLabel: String,

        // In-page, i.e. not really modal
        inPage: Boolean,
    },
};
